import { createSelector } from 'reselect';

const localState = ({ propertyFeatures }) => propertyFeatures;

export const getKitchenAvgSizeSelector = createSelector(
  localState,
  ({ kitchenAvgSize }) => kitchenAvgSize,
);
